import { EPopupSubType } from 'constants/enums';
import { OfferDesignTypes } from 'views/OffersUI/OffersUIForm/types';

import bonusImg from '../assets/bonus.png';
import bundleImg from '../assets/bundle.png';
import progressImg from '../assets/progress.png';
import promotionImg from '../assets/promotion.png';
import rewardImg from '../assets/reward.png';
import rollingImg from '../assets/rolling.png';
import triggeredImg from '../assets/triggered.png';
import { OfferTypeCardConfig } from '../types';

export const OFFER_TYPE_CARDS: OfferTypeCardConfig[] = [
  {
    key: 'promotions',
    title: 'Promotions',
    description: 'Scheduled promotions featuring one or more products.',
    image: promotionImg,
    offerDesignType: OfferDesignTypes.SpecialOffer
  },
  {
    key: 'bundle',
    title: 'Bundle',
    description: 'Bundles of products sold at a discount or with bonus items.',
    image: bundleImg,
    offerDesignType: OfferDesignTypes.Bundle
  },
  {
    key: 'daily-bonus',
    title: 'Daily Bonus',
    description: 'Recurring rewards that encourage players to return.',
    image: bonusImg,
    offerDesignType: OfferDesignTypes.PopUp,
    subType: EPopupSubType.DAILY_BONUS
  },
  {
    key: 'rolling-offer',
    title: 'Rolling Offer',
    description: 'Unlock the next deal automatically after each purchase.',
    image: rollingImg,
    offerDesignType: OfferDesignTypes.RollingOffer
  },
  {
    key: 'triggered-popup',
    title: 'Triggered Popup',
    description: 'Contextual offers that appear based on player behavior or events.',
    image: triggeredImg,
    offerDesignType: OfferDesignTypes.PopUp,
    subType: EPopupSubType.POST_PURCHASE
  },
  {
    key: 'progress-bar',
    title: 'Progress Bar',
    description: 'Visual trackers that reward players for completed actions.',
    image: progressImg,
    offerDesignType: OfferDesignTypes.ProgressBar
  },
  {
    key: 'reward-calendar',
    title: 'Reward Calendar',
    description: 'Time-based rewards that unlock daily or periodic rewards.',
    image: rewardImg,
    offerDesignType: OfferDesignTypes.SpecialOffer,
    disabled: true
  }
];
